import { lazy, Suspense } from 'react';

// Scalar is a heavy dependency; keep it out of the main bundle and only
// load it when someone opens the explorer.
const ScalarViewer = lazy(() => import('./ScalarViewer'));

export function EdmsExplorerPage() {
  return (
    <div className='w-full'>
      <div className='mb-4 bg-white px-6 py-4'>
        <h1 className='size-h2 text-primary font-bold'>EDMS API</h1>
        <p className='size-p2 text-secondary mt-2'>
          This page calls the live EDMS API behind this Pulse instance,
          passing your own login along — responses are real data, exactly
          what Pulse receives. Only read-only (GET) requests are allowed.
        </p>
      </div>
      <Suspense
        fallback={<div className='text-secondary'>Loading API explorer…</div>}
      >
        <ScalarViewer />
      </Suspense>
    </div>
  );
}
